import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'tgx-web-site-public-v3-sign-up-register',
  templateUrl: './v3-sign-up-register.component.html',
  styleUrls: ['./v3-sign-up-register.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class V3SignUpRegisterComponent {
  protected userEmail: string | null = null;

  protected updateUserEmail(email: string): void {
    this.userEmail = email;
  }
}
